var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:_vm.linkClass,on:{"click":_vm.onClick}},[_vm._t("default",function(){return [_c('div',{staticClass:"icon-bg"},[_c('Icon',{style:(_vm.network.style),attrs:{"name":_vm.network.icon,"width":"26"}})],1),(!_vm.hideLabel)?_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.network.label))]):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }